import React, { Component } from 'react';
import { MDBModal, MDBModalHeader, MDBModalBody, MDBModalFooter, toast, ToastContainer, MDBCardImage, MDBTooltip, MDBBadge, MDBCardFooter, MDBPageNav, MDBPageItem, MDBPagination, MDBInput, MDBBtn, MDBCard, MDBCardTitle, MDBCardText, MDBCardBody, MDBIcon, MDBRow, MDBCol } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Formatter from '../Utilities/Formatter';
import Header from './ComponentFragments/Header';


class Shop extends Component {
    constructor(props) {
        super(props);
        this.TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        this.state = ({
            active: true,
            selectedPage: 1,
            shopData: [],
            filteredData: [],
            displayData: [],
            pageSize: 20,
            maxPages: 0,
            pages: [],
            dummy: 0,
            errorModalOpen: false,
            shopErrorMsg: '',
            shopSuspended: false,
            //cartData: [],
            roadshowItem: {}
        });
        this.formatter = new Formatter();
        this.searchList = this.searchList.bind(this);
        this.getPagination = this.getPagination.bind(this);
        this.getPage = this.getPage.bind(this);
        this.getShopData = this.getShopData.bind(this);
        this.addToCart = this.addToCart.bind(this);
        this.getParams = this.getParams.bind(this);
        this.getButton = this.getButton.bind(this);
        this.getHot = this.getHot.bind(this);
        this.toggleErrorInfo = this.toggleErrorInfo.bind(this);
    }

    toggleErrorInfo() {
        //this.setState({
        //    errorModalOpen: !this.state.errorModalOpen
        //});
        window.location.reload();
        return false;
    }

    componentWillMount() {
        this.getShopData();

    }

    getPage(pageNo, maxPages, data) {
        let lowerBound = pageNo - 4;
        let upperBound = pageNo + 4;
        let pages = [];

        if (maxPages > 9) {
            if (lowerBound < 1) {
                lowerBound = 1;
                upperBound = 9;
            }

            if (upperBound > maxPages) {
                upperBound = maxPages;
                lowerBound = maxPages - 8;
            }
        } else {
            lowerBound = 1;
            upperBound = maxPages;
        }

        for (var i = lowerBound; i <= upperBound; i++) {
            pages.push(i);
        }

        let newData = this.getPageData(this.state.pageSize, pageNo, data);

        this.setState({
            selectedPage: pageNo,
            displayData: newData,
            pages
        })

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    getPageData(pageSize, pageNo, data) {
        let max = (pageSize * pageNo) - 1;
        let min = (max - pageSize) + 1;

        return data.slice(min, max + 1);
    }

    componentDidUpdate(prevProps) {
        var prevParams = prevProps.match.params.categoryId;
        var currParams = this.props.match.params.categoryId;
        if (prevParams !== currParams) {
            this.getShopData();
        }
    }

    async getShopData() {
        this.props.loaderOn();
        //let routeParam = this.props.getRouteParam();
        var dl = new DataLayer();
        let suspendedResponse = await dl.Get('/shop/CheckShopSuspended')
        //let cartResponse = await dl.Get("/common/getcart/false", 1);

        //check to see if this dem has already ordered one of the roadshow items.
        let roadShowItemResponse = await dl.Get("/demonstrator/checkForRoadshowItem")

        if (!suspendedResponse.data.mobiOrderingAllowed) {
            this.setState({ shopSuspended: true });
        } else {
            let response = await dl.Get('/common/getshopdata/' + this.props.match.params.categoryId);

            this.setState({
                shopSuspended: false,
                shopData: response.data,
                filteredData: response.data,
                maxPages: Math.ceil(response.data.length / this.state.pageSize),
                //cartData: cartResponse.data,
                roadshowItem: roadShowItemResponse.data
            });
            this.getPage(1, Math.ceil(response.data.length / this.state.pageSize), response.data);
        }
        this.props.loaderOff();
    }


    async addToCart(item) {
        //alert(document.getElementById(stockId).valueAsNumber);
        let procCode1 = this.TMAUser.data.countryId == 6 ? '991527' : '991529';
        let procCode2 = this.TMAUser.data.countryId == 6 ? '991528' : '991530';
            

        if (item.processingCode == procCode1 || item.processingCode == procCode2) {
            if (this.state.roadshowItem.onInvoice || this.state.roadshowItem.onOrder || this.state.roadshowItem.inOpenCart) {
                toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;Unable to add Item. Item has already been ordered</span>, {
                    closeButton: false
                });
                return;
            }
            if (document.getElementById(item.itemKey).valueAsNumber > 1) {
                toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;Unable to add Item. Only 1 is allowed.</span>, {
                    closeButton: false
                });
                return;
            }
            if (this.state.roadshowItem.cartItemCount > 0) {
                toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;Unable to add Item. Cart has other items.</span>, {
                    closeButton: false
                });
                return;
            }
        } else {
            if (this.state.roadshowItem.inOpenCart) {
                toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;Unable to add Item. Cart Contains Roadshow Item</span>, {
                    closeButton: false
                });
                return;
            }
        }


        
        if (document.getElementById(item.itemKey).value == "" || document.getElementById(item.itemKey).valueAsNumber < 1) {
            toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;Please give a valid Qty.</span>, {
                closeButton: false
            });

        } else {
            this.props.loaderOn();
            item.qty = document.getElementById(item.itemKey).valueAsNumber;
            var dl = new DataLayer();
            let response = await dl.Post('/common/addtocart', item, false);
            if (response.errorOccurred) {
                //toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;Error Occurred.</span>, {
                //    closeButton: false
                //});
                this.setState({ errorModalOpen: true, shopErrorMsg: response.errorMessage });
            } else {
                toast.success(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="check-circle" />&nbsp;&nbsp; {document.getElementById(item.itemKey).valueAsNumber == 1 ? "Item added successfully." : "Items added successfully."} </span>, {
                    closeButton: false
                });
                this.props.updateCartCount(response.data);
            }
            let roadShowItemResponse = await dl.Get("/demonstrator/checkForRoadshowItem")
            this.setState({
                roadshowItem: roadShowItemResponse.data
            });
        }
        this.props.loaderOff();
    }

    getPagination() {
        let isFirst = this.state.selectedPage == 1 ? true : false;
        let isLast = this.state.maxPages == this.state.selectedPage ? true : false;
        return (
            <MDBPagination circle style={{ justifyContent: "center" }}>
                <MDBPageItem disabled={isFirst}>
                    <MDBPageNav className="page-link" onClick={() => this.getPage(this.state.selectedPage - 1, this.state.maxPages, this.state.filteredData)}>
                        &laquo;
                    </MDBPageNav>
                </MDBPageItem>
                {
                    this.state.pages.map((pageNo) => {
                        let active = pageNo == this.state.selectedPage ? true : false;
                        return (

                            <MDBPageItem active={active}>
                                <MDBPageNav className="page-link" onClick={() => this.getPage(pageNo, this.state.maxPages, this.state.filteredData)}>
                                    {pageNo}
                                </MDBPageNav>
                            </MDBPageItem>

                        )
                    })
                }
                <MDBPageItem disabled={isLast}>
                    <MDBPageNav className="page-link" onClick={() => this.getPage(this.state.selectedPage + 1, this.state.maxPages, this.state.filteredData)}>
                        &raquo;
                    </MDBPageNav>
                </MDBPageItem>

            </MDBPagination>
        );
    }

    getButton(item) {
        if (!item.preventOrdering) {
            return (
                <MDBRow>
                    <MDBCol>
                        <MDBInput id={item.itemKey} min={0} type="number" label="Qty" required />
                    </MDBCol>
                    <MDBCol className="text-center">
                        <MDBBtn type="submit" tag="a" color="cyan" floating onClick={() => this.addToCart(item)}>
                            <MDBIcon icon="cart-plus" />
                        </MDBBtn>

                    </MDBCol>
                </MDBRow>
            );
        } else {
            return (
                <MDBRow>
                    <MDBCol className="text-center">
                        Out of stock, cannot be ordered.<hr className="hr_grey" />
                    </MDBCol>
                </MDBRow>
            );
        }
    }

    getParams(item) {
        if (item.showOutOfStock) {
            if (item.preventOrdering) {
                return (
                    <span>( <MDBIcon icon="exclamation-triangle" className="red-text" /> out of Stock)</span>
                );
            } else {
                return (
                    <span>( <MDBIcon icon="exclamation-triangle" className="red-text" /> Low on Stock)</span>
                );
            }
        }
    }

    searchList(phrase) {
        let arr = this.state.shopData.filter((item) => (item.recognition.toString().includes(phrase)) || item.processingCode.toUpperCase().includes(phrase.toUpperCase()) || (item.invoiceDescription.toUpperCase().includes(phrase.toUpperCase())))
        this.setState({
            filteredData: arr,
            maxPages: Math.ceil(arr.length / this.state.pageSize)
        });
        this.getPage(1, Math.ceil(arr.length / this.state.pageSize), arr);

    }

    getHot(item, forHot) {
        if (forHot) {
            if (item.hotItem) {
                return (
                    <MDBCardBody>
                        <div>
                            <div className="right-side-meta"><MDBIcon style={{ fontSize: '25px' }} icon="fire-alt" className="red-text" />&nbsp;Hot Item</div>
                        </div>
                    </MDBCardBody>
                )
            }
        } else {
            if (item.saving > 0) {
                return (
                    <div>
                        <h5><MDBBadge className="priceBadge" color="secondary">Price: {this.formatter.formatCurrency(item.d)}<br /><span style={{ fontSize: "10px", fontWeight: "normal" }}>(excl vat)</span></MDBBadge></h5>
                        <MDBBadge className="specialBadge" color="transparent"><span style={{ color: 'red', fontSize: '14px', fontWeight: 'normal' }}>Save: {this.formatter.formatCurrency(item.saving)}</span></MDBBadge>
                    </div>
                )
            } else {
                return (
                    <div>
                        <h5><MDBBadge className="priceBadge" color="secondary">Price: {this.formatter.formatCurrency(item.d)}<br /><span style={{ fontSize: "10px", fontWeight: "normal" }}>(excl vat)</span></MDBBadge></h5>
                        
                    </div>
                )
            }
        }
    }

    render() {
        let header = "Shop (" + this.props.getRouteParam() + ")"
        this.TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        let shipId = this.TMAUser.data.shipId;
        return (
            <div id="top">
                <Header headerText={header}
                    subHeaderText="(Please note if there is no activity on your cart for 30mins or more it will automatically be cleared)"
                    placeholderText="Search"
                    searchList={this.searchList}
                />
                <MDBRow>
                    {this.state.shopSuspended ? <div><h5>Shop has temporarily been suspended by your distributor. Please check back soon.</h5></div> :
                        this.state.displayData.map((item) => {

                            return (

                                <MDBCol xl="3" lg="4" md="6" sm="12" className="mb-r" >
                                    <div key={item.itemKey}>
                                        <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                                            {/*<MDBCardImage className="img-fluid" src={`https://tupp.tuppafrica.co.za/images/virtualstore/` + item.stockId + `.jpg`} waves />*/}
                                            <div>
                                            {this.getHot(item, true)}

                                            <MDBCardImage className="img-fluid" src={item.hasImage ? item.shipStockId > 0 ? `https://tupp.tuppafrica.co.za/Images/virtualstore/` + shipId + `_` + item.shipStockId + `.jpg` : `https://tupp.tuppafrica.co.za/Images/virtualstore/` + item.stockId + `.jpg` : `https://tupp.tuppafrica.co.za/images/virtualstore/noimage.png`} />
                                            
                                            
                                                {this.getHot(item, false)}
                                                </div>
                                            <br />
                                            <MDBCardText>
                                                <span style={{ fontSize: "16" }}><strong>{item.processingCode}  </strong></span>{this.getParams(item)}<br />
                                                <span style={{ fontSize: "10" }}>{item.invoiceDescription}</span><br /><br />
                                                <span style={{ fontSize: "16" }}>Recognition:&nbsp;<strong>{this.formatter.formatCurrency(item.recognition)}</strong></span><br />
                                            </MDBCardText>
                                            <hr className="hr_grey" />
                                            {/*<div className="flex-row text-center" >*/}

                                            {this.getButton(item)}



                                            {/*</div>*/}
                                        </MDBCard>
                                    </div>
                                </MDBCol>
                            )

                        })
                    }
                </MDBRow>
                {this.state.shopSuspended ? <div></div> :
                    <MDBRow className="mt-4">
                        <MDBCol>

                            {this.getPagination()}

                        </MDBCol>
                    </MDBRow>
                }
                <MDBModal isOpen={this.state.errorModalOpen} toggle={this.state.errorModalOpen} centered>
                    <MDBModalHeader>Alert</MDBModalHeader>
                    <MDBModalBody>
                        {this.state.shopErrorMsg}
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={this.toggleErrorInfo}>Ok</MDBBtn>

                    </MDBModalFooter>
                </MDBModal>
                <ToastContainer
                    hideProgressBar={true}
                    newestOnTop={true}
                    autoClose={5000}
                />
            </div>

        )
    }
}

export default Shop;


